import type { CartItemTypeEnum } from '../cart/cart-item.ts';
import type { CartItemSponsorshipSelected } from '../cart/sponsorship.ts';
import type {
  ChildBase,
  ChildBirthday,
  ChildGender,
  ChildIcp,
  ChildImageUrl,
  ChildName,
} from '../children/childUtilityInterfaces.ts';

export enum UpsellItemTypeEnum {
  Fund = 'Fund',
  Sponsorship = 'Sponsorship',
}

type UpsellItemBase = {
  title?: string;
  subtitle?: string;
};

export type UpsellSponsorshipItem = UpsellItemBase & {
  itemType: CartItemTypeEnum.Sponsorship;
  child: ChildBase &
    ChildBirthday &
    ChildGender &
    ChildImageUrl &
    ChildIcp &
    ChildName;
  sponsorship: CartItemSponsorshipSelected;
};

export type UpsellFundItem = UpsellItemBase & {
  itemType: CartItemTypeEnum.Fund;
  fund: {
    cmsId: string;
    icon?: string | null;
    title: string;
  };
  unitPrice: number;
};

export type UpsellItem = UpsellSponsorshipItem | UpsellFundItem;
